<div class="prs-account-menu" [class.prs-header-account--open]="open">
  <button
    type="button"
    class="prs-header-account-link"
    data-testing-id="header-account-menu"
    (click)="toggle()"
    [attr.aria-expanded]="open"
    [attr.aria-controls]="'prs-account-menu-panel'"
    [attr.aria-label]="'account.login_status.myaccount.link' | translate"
  >
    <i class="bi bi-person-circle prs-header-account-icon" aria-hidden="true"></i>
    <span class="prs-header-account-name">{{ displayName$ | async }}</span>
    <i class="bi bi-chevron-down prs-header-account-chevron" aria-hidden="true"></i>
  </button>

  <div
    *ngIf="open"
    id="prs-account-menu-panel"
    class="prs-account-menu__panel prs-account-menu__panel--compact"
    role="menu"
  >
    <a
      class="prs-account-menu__item"
      role="menuitem"
      routerLink="/account"
      data-testing-id="link-myaccount"
      (click)="close()"
    >
      {{ 'account.my_account.link' | translate }}
    </a>
    <a
      class="prs-account-menu__item"
      role="menuitem"
      routerLink="/logout"
      data-testing-id="link-logout"
      (click)="close()"
    >
      {{ 'account.logout.link' | translate }}
    </a>
  </div>
</div>
